import { Controller } from "@hotwired/stimulus";

// Polls the server for the current build and, when it differs from the build
// the page was loaded with, reveals a friendly "refresh" toast.
//
// Connects to data-controller="version-check"
export default class extends Controller {
  static targets = ["toast"];
  static values = {
    current: String,
    url: { type: String, default: "/version.json" },
    interval: { type: Number, default: 120000 }, // 2 minutes
  };

  connect() {
    if (!this.currentValue || this.currentValue === "unknown") return;
    this.timer = setInterval(() => this.check(), this.intervalValue);
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer);
  }

  async check() {
    try {
      const response = await fetch(this.urlValue, {
        headers: { Accept: "application/json" },
        cache: "no-store",
      });
      if (!response.ok) return;

      const data = await response.json();
      if (data.version && data.version !== this.currentValue) {
        this.reveal();
      }
    } catch (_error) {
      // Network hiccup — try again on the next tick.
    }
  }

  reveal() {
    if (this.timer) clearInterval(this.timer);
    if (!this.hasToastTarget) return;

    this.toastTarget.classList.remove("hidden");
    requestAnimationFrame(() => {
      this.toastTarget.classList.remove("translate-y-4", "opacity-0");
    });
  }

  refresh() {
    window.location.reload();
  }

  dismiss() {
    if (!this.hasToastTarget) return;

    this.toastTarget.classList.add("translate-y-4", "opacity-0");
    setTimeout(() => this.toastTarget.classList.add("hidden"), 300);
  }
}
